function capitalize(string) {
  return string
    .split(' ')
    .map((s) => s[0].toUpperCase() + s.slice(1))
    .join(' ')
}

function formatName(name) {
  return capitalize(name.replace(/-/gi, ' '))
}

function createSchema(project) {
  return {
    id: project.id,
    name: formatName(project.name),
    url_preview: project.homepage,
    url_github: project.html_url,
    img: `https://raw.githubusercontent.com/N-bred/${project.name}/master/frontCard.png`,
    description: project.description,
    date: project.updated_at,
  }
}

export function transformResponse(response) {
  return response.filter((project) => project.homepage).map(createSchema)
}
